import React from "react";
import { Navbar, NavItem } from "reactstrap";
import { NavLink } from "react-router";
import "./NavMenu.css";
import useAuth from "../hooks/useAuth";

export default function NavMenu() {
  const { auth, setAuth } = useAuth();

  var path = auth.viewLevel === "adminreports" ? "" : "/myreports";

  return (
    <header>
      <Navbar
        className="navbar-expand-sm navbar-toggleable-sm ng-white border-bottom box-shadow mb-3"
        container
      >
        <ul className="navbar-nav flex-grow">
          <NavItem>
            <NavLink
              to={`${path}/`}
              className={({ isActive }) =>
                `nav-link ${isActive ? "active" : ""}`
              }
              end
            >
              Reports
            </NavLink>
          </NavItem>
          <NavItem>
            <NavLink
              to={`${path}/reports`}
              className={({ isActive }) =>
                `nav-link ${isActive ? "active" : ""}`
              }
            >
              User Reports
            </NavLink>
          </NavItem>
        </ul>
        <div className="nav-link">
          Your data is refreshed in the background every hour.
        </div>
      </Navbar>
    </header>
  );
}
